import { type RedlineTextProposal, textsPayloadFrom } from "@common/utils/redline/wire/redline-payload";

import { AnchoredProposal } from "../../utils/anchor/proposal/anchored-proposal";
import { editLayerStampAfter } from "../../utils/anchor/proposal/live-proposal";
import type { EditBoxReview } from "../chat/proposal-edit/ProposalEditor";

export function editBoxReviewPackageOf(textRedlineProposed: RedlineTextProposal, author: string, review: EditBoxReview): string | null {
    try {
        return new AnchoredProposal(textsPayloadFrom(textRedlineProposed), "asTrackedChange").layerEditOverPackage(review.packageOoxml, review.stampedAt, {
            textRedline: review.draft,
            author,
            stampedAt: editLayerStampAfter(review.stampedAt),
            textRedlineWhenOpened: review.textRedlineBoxReads,
        }).packageOoxml;
    } catch {
        return null;
    }
}
